/**
 * Квантование ширины рендера страницы (§7.1).
 *
 * Отдельным модулем от `usePdfPage.ts`, и это не вкусовщина: тот тянет за собой
 * браузерную сборку pdf.js, которой нужен DOM (`DOMMatrix`), и проверить в
 * тесте одну арифметическую функцию через неё нельзя. То же разделение, что у
 * `packages/detection` с его нативной обвязкой: числовая часть не должна
 * зависеть от того, где её исполняют.
 *
 * ## Зачем квантовать
 *
 * `PageCanvas` рисует изображение через `KonvaImage` с явными `width`/`height`,
 * то есть масштабирует канву сам. Значит разрешение рендера НЕ обязано совпадать
 * с размером показа, и это развязывает две вещи, которые раньше были склеены:
 * шаг масштаба и повторный рендер. Раньше каждый шаг `ZOOM_STEPS` менял целевую
 * ширину и запускал полную повторную отрисовку страницы; теперь соседние
 * масштабы попадают в одну ступень и переиспользуют уже готовую канву.
 *
 * Вторая причина — сам кэш. `ResizeObserver` отдаёт `contentRect.width` дробным,
 * и без квантования каждый пиксель ширины окна был бы отдельным ключом кэша,
 * то есть кэша не было бы вовсе.
 *
 * Квантование ВВЕРХ, а не вниз: канва крупнее показа ужимается при отрисовке и
 * выглядит резко; более мелкая растягивалась бы и мылила.
 */

/**
 * Ступень квантования, CSS-пиксели.
 *
 * Крупнее ступень — реже повторный рендер и выше попадание в кэш, но больше
 * лишних пикселей. 256 выбрано так, чтобы вся лестница `ZOOM_STEPS` на типичной
 * ширине области укладывалась в считанные ступени.
 */
export const RENDER_WIDTH_STEP = 256;

/** Ширина рендера для заданной ширины показа. */
export function renderWidthFor(displayWidth: number): number {
  const safe = Number.isFinite(displayWidth) ? Math.max(1, displayWidth) : 1;
  const stepped = Math.ceil(safe / RENDER_WIDTH_STEP) * RENDER_WIDTH_STEP;
  return Math.max(RENDER_WIDTH_STEP, stepped);
}
